module.exports = __webpack_public_path__ + "img/instagram_icon.e146c633.png";